module.exports = __webpack_public_path__ + "img/示范园.a05bb801.png";